import { useSearchParams, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ParticipantQueueView from '@/components/queue/ParticipantQueueView';
import { AlertCircle } from 'lucide-react';

export default function UsuarioFila() {
  const [searchParams] = useSearchParams();
  const { entryId } = useParams<{ entryId?: string }>();
  const [queueId, setQueueId] = useState<string | null>(null);
  const [directEntryId, setDirectEntryId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Check if we have a direct entry ID from the URL path
    if (entryId) {
      setDirectEntryId(entryId);
      // We'll fetch the queue ID from the entry in the component
      return;
    }
    
    // Otherwise, check for queue ID in query params
    const queueIdParam = searchParams.get('queueId');
    
    if (!queueIdParam) {
      setError('ID da fila não fornecido. Verifique o link e tente novamente.');
      return;
    }
    
    setQueueId(queueIdParam);
  }, [searchParams, entryId]);

  const handleLeaveQueue = () => {
    // Redirect to a thank you page or show a message
    window.location.href = '/';
  };

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-card rounded-ds-card shadow-lg p-6 max-w-md w-full text-center">
          <AlertCircle className="mx-auto mb-4 text-status-danger" size={48} />
          <h1 className="text-xl font-bold text-foreground mb-2">Erro</h1>
          <p className="text-muted-foreground mb-4">{error}</p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-primary text-primary-foreground px-4 py-2 rounded-lg hover:bg-primary transition-colors"
          >
            Voltar ao Início
          </button>
        </div>
      </div>
    );
  }

  if (!queueId && !directEntryId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <ParticipantQueueView 
        queueId={queueId}
        entryId={directEntryId}
        onLeaveQueue={handleLeaveQueue}
      />
    </div>
  );
}